export default {
    PNG: 'PNG',
    ZIP: 'ZIP',
};

